const retentions = [
    { Id: 900, Desc: "Retencion IIBB", jurisdiccion:true },
    { Id: 901, Desc: "Retencion IVA", jurisdiccion:false },    
    { Id: 902, Desc: "Retencion Ganancias", jurisdiccion:false },
    { Id: 903, Desc: "Retencion SUSS", jurisdiccion:false },
    { Id: 904, Desc: "Retencion Seguridad e Higiene", jurisdiccion:false },
    { Id: 999, Desc: "Otros", jurisdiccion:false },
  ];

export default {
  retentions: retentions,
};
